export const EMPTY_FILTERS = {
  batchId: '',
  type: '',
  fileName: '',
  accountId: '',
};

export const TYPE_OPTIONS = ['USER_CREATION', 'VOUCHER_CREATION', 'USER_DEACTIVATION', 'TXN'];

export const DOWNLOAD_PAGE_SIZE = 100000;
